export function controlRangeInput(input_range, input) {

    if(input_range && input) {
        let sum_min = +input_range.min;
        let sum_max = +input_range.max;

        let updateInput = () => {
            let sum_current = input_range.value;
            let percentage = (100 * (sum_current - sum_min)) / (sum_max - sum_min);

            //input.value = new Intl.NumberFormat('ru').format(sum_current);
            input_range.style.background = `linear-gradient(90deg, #4C679C ${percentage}%, #D0D1D0 ${percentage}%)`;
        }; updateInput();


        input_range.addEventListener('input', updateInput);


        input.addEventListener('input', () => {
            input.value = input.value.replace(/[^0-9\s]/g, '');
        });


        input.addEventListener('change', () => {
            let input_value = +input.value.replace(/\s/g, '');
            let value_fixed = input_value < sum_min ? sum_min : input_value > sum_max ? sum_max : input_value;

            input.value = new Intl.NumberFormat('ru').format(value_fixed);
            input_range.value = value_fixed;

            updateInput();
        });
    }
};
